// ===============================
// COMMON LABEL
// ===============================

export const getScoreLabel = (score) => {
  if (score >= 85) return "Strong Bullish";

  if (score >= 70) return "Bullish";

  if (score >= 55) return "Moderately Bullish";

  if (score >= 45) return "Neutral";

  if (score >= 30) return "Bearish";

  return "Strong Bearish";
};

// ===============================
// RSI + MACD SCORE
// ===============================

export const getRsiMacdScore = ({ rsi, macd, signal, histogram }) => {
  let score = 50;

  // RSI

  if (rsi >= 70) score += 20;
  else if (rsi >= 60) score += 15;
  else if (rsi >= 50) score += 10;
  else if (rsi >= 45) score += 5;
  else if (rsi <= 30) score -= 20;
  else if (rsi <= 40) score -= 15;

  // MACD

  if (macd > signal) score += 15;
  else score -= 15;

  // Histogram

  if (histogram > 0) score += 10;
  else score -= 10;

  return Math.max(0, Math.min(100, Math.round(score)));
};

// ===============================
// VWAP SCORE
// ===============================

export const getVwapScore = ({ ltp, vwap }) => {
  if (!ltp || !vwap) return 50;

  const percent = ((ltp - vwap) / vwap) * 100;

  if (percent >= 2) return 90;

  if (percent >= 1) return 80;

  if (percent >= 0.5) return 70;

  if (percent >= 0) return 60;

  if (percent <= -2) return 10;

  if (percent <= -1) return 25;

  if (percent < 0) return 40;

  return 50;
};

// ===============================
// MOMENTUM SCORE
// ===============================

export const getMomentumScore = ({ prediction, utSignal, bbSignal }) => {
  let score = 50;

  if (prediction === "Bullish") score += 20;

  if (prediction === "Bearish") score -= 20;

  if (utSignal === "Bullish" || utSignal === "BUY") {
    score += 15;
  }

  if (utSignal === "Bearish" || utSignal === "SELL") {
    score -= 15;
  }

  if (bbSignal === "Bullish" || bbSignal === "BUY") {
    score += 15;
  }

  if (bbSignal === "Bearish" || bbSignal === "SELL") {
    score -= 15;
  }

  return Math.max(0, Math.min(100, score));
};

// ===============================
// OVERALL SCORE
// ===============================

export const getOverallScore = ({
  rsiMacdScore,
  vwapScore,
  smartMoneyScore,
  momentumScore,
}) => {
  const overall =
    rsiMacdScore * 0.3 +
    vwapScore * 0.25 +
    smartMoneyScore * 0.25 +
    momentumScore * 0.2;

  return Math.round(overall);
};

// ===============================
// MASTER FUNCTION
// ===============================

export const getTechnicalScores = ({
  rsi,
  macd,
  signal,
  histogram,

  ltp,
  vwap,

  smartMoneyScore,

  prediction,
  utSignal,
  bbSignal,
}) => {
  const rsiMacdScore = getRsiMacdScore({
    rsi,
    macd,
    signal,
    histogram,
  });

  const vwapScore = getVwapScore({
    ltp,
    vwap,
  });

  const momentumScore = getMomentumScore({
    prediction,
    utSignal,
    bbSignal,
  });

  const overallScore = getOverallScore({
    rsiMacdScore,
    vwapScore,
    smartMoneyScore,
    momentumScore,
  });

  return {
    rsiMacdScore,

    vwapScore,

    momentumScore,

    smartMoneyScore,

    overallScore,

    rsiMacdLabel: getScoreLabel(rsiMacdScore),

    vwapLabel: getScoreLabel(vwapScore),

    momentumLabel: getScoreLabel(momentumScore),

    overallLabel: getScoreLabel(overallScore),
  };
};
